import { useEffect, useState } from "react";
import { Institution } from "byzantine/src/types";
import { useNotificationContext } from "cerulean/src/NotificationContext";
import jsonFromDocument from "cerulean/src/JsonFromDocument";

const useInstitutionSettings = () => {
  const apiUrl = jsonFromDocument("api_url");
  const { sendNotification } = useNotificationContext();
  const [institution, setInstitution] = useState<Institution>({
    long_name: "",
  });

  useEffect(() => {
    const fetchInstitution = async () => {
      const response = await fetch(`${apiUrl}/v1/institution/`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        sendNotification({
          type: "negative",
          text: "Server error fetching institution data. Please contact support.",
        });
        return;
      }
      const data = await response.json();
      setInstitution(data.institution);
    };
    fetchInstitution();
  }, []);

  return institution;
};

export default useInstitutionSettings;
